module.exports = __webpack_public_path__ + "static/media/challenge-background-tasks-mountains.c677099f.svg";